import Tag from '@e3dc-react/shell/Elements/Tags/Tag'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { useGraphicBaseCard } from 'src/Libs/graph-cards'
import { UnitType } from 'src/Libs/types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Theme, useMediaQuery } from '@mui/material'
import { SelectedValue, Unit } from 'src/Elements/SystemSettings/SystemSettingsUtils'

const useStyles = makeStyles()(theme => ({
  tags: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    textAlign: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
}))

interface Props {
  sourceValues: number[]
  selectedValues: SelectedValue[]
  tagUnit: Unit
  tagLabel?: (value: number, index: number, unit: UnitType) => string | React.ReactNode
  onClickTag: (idx: number) => void
}

const GraphTagList: React.VFC<Props> = ({ tagUnit, sourceValues, selectedValues, tagLabel, onClickTag }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { getGraphValueBackgroundColor } = useGraphicBaseCard()
  const downLg = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
  return (
    <div className={classes.tags}>
      {sourceValues.map((value, idx) => {
        const [color, backgroundColor] = getGraphValueBackgroundColor(idx, 'light', sourceValues)
        const displayedValue = Math.round(value * 10) / 10
        const defaultTagContent = t('component.GraphicBaseCard.defaultTag', { value: displayedValue.toFixed(2), index: idx + 1 })
        const content = tagLabel ? tagLabel(displayedValue, idx, tagUnit) : defaultTagContent
        return (
          <Tag
            key={idx}
            index={idx}
            label={content}
            size={downLg ? 'small' : 'medium'}
            color={backgroundColor}
            fontColor={color}
            isSelected={selectedValues.length === 0 ? true : selectedValues?.[idx]?.isSelected}
            onClick={onClickTag}
          />
        )
      })}
    </div>
  )
}

export default GraphTagList
